/* tt-pdp: running total and the extra designs (Ontwerp 2 to 4, window.TTExtras from tt-extra-ontwerp.js) in the same /cart/add call. */
(function () {
  'use strict';

  var cents = function (s) {
    var m = String(s || '').match(/(\d[\d.,'  ]*)/);
    if (!m) return null;
    var t = m[1].replace(/[  ']/g, ''), d = t.match(/[.,](\d{2})$/);
    return d ? parseInt(t.slice(0, -3).replace(/[.,]/g, '') || '0', 10) * 100 + parseInt(d[1], 10) : parseInt(t.replace(/[.,]/g, ''), 10) * 100;
  };
  var fmt = function (c) { return window.ttMoney(c); }; // the one theme formatter (layout/theme.liquid)
  var X = function () { return window.TTExtras || null; };
  // r20pdp: ONE amount per order line, the field input[name=quantity] next to the buy button (main-product.liquid). The ceiling is the one of the group steppers
  // (tt-groep.liquid max="99"). Odd input is turned into a number here, never refused: 0, empty, letters and negatives become 1, 1000 becomes 99, 2.7 becomes 2.
  // While the group panel is open it is the only source of amounts: the loose field is hidden and switched off (a disabled field is not in the form data), so nothing counts twice.
  var QMAX = 99;
  var normQty = function (v) { var n = parseInt(v, 10); return isFinite(n) && n >= 1 ? Math.min(QMAX, n) : 1; };
  var qField = function () { return document.querySelector('input[name="quantity"]'); };
  var pieces = function () { var G = window.TTGroep; if (G && G.isOpen()) return 1; var q = qField(); return normQty(q && q.value); };
  function syncAantal(total) {
    var wrap = document.querySelector('[data-tt-aantal]'), q = qField(), G = window.TTGroep;
    if (!wrap) return;
    var off = !!(G && G.isOpen());
    if (wrap.hidden !== off) wrap.hidden = off;
    if (q && q.disabled !== off) q.disabled = off;
    var out = wrap.querySelector('[data-tt-aantal-totaal]');
    if (out && total !== undefined && out.textContent !== total) out.textContent = total;
  }
  function stepAantal(d) {
    var q = qField(); if (!q || q.disabled) return;
    q.value = String(normQty(normQty(q.value) + d));
    q.dispatchEvent(new Event('input', { bubbles: true })); q.dispatchEvent(new Event('change', { bubbles: true }));
  }

  // r16toeslag: surcharge lines for the ACTIVE style and size button. Variant id and cents come from the helper product (Liquid), never typed here.
  var warned = {};
  function warn(key, msg) { if (!warned[key]) { warned[key] = true; if (window.console) console.error('tt-toeslag: ' + msg); } }
  function toeslagen() {
    var out = [], host = document.querySelector('borduur-personalisatie');
    if (host && host.dataset.toeslagMiss) warn('miss', 'geen toeslagproduct voor ' + host.dataset.toeslagMiss + ', er wordt geen toeslag gerekend');
    [['stijl', '[data-bp-stijl] .bp__style.is-active'], ['formaat', '[data-bp-formaat] .bp__fmt.is-active']].forEach(function (k) {
      var b = document.querySelector(k[1]);
      if (!b) return;
      if (b.dataset.toeslagMiss) warn(b.dataset.toeslagMiss, 'geen variant voor "' + b.dataset.toeslagMiss + '", er wordt geen toeslag gerekend');
      var c = parseInt(b.dataset.cents, 10) || 0;
      if (c > 0 && b.dataset.variant) out.push({ kind: k[0], variant: b.dataset.variant, cents: c });
    });
    return out;
  }

  // total = (main price on the page + style and size surcharge + every extra design with its format surcharge) x pieces: the same sum as the lines of the cart
  function updateTotal() {
    var G = window.TTGroep;
    if (G) { // r18maten: the group panel prices every stepper with the same surcharges per piece
      G.perPiece = function () { var c = X() ? X().perPiece() : 0; toeslagen().forEach(function (t) { c += t.cents; }); return c; };
      G.refresh();
    }
    syncAantal();
    var out = document.querySelector('[data-bp-total]');
    var priceEl = document.querySelector('.price-item--last');
    if (!out || !priceEl) return;
    var base = cents(priceEl.textContent);
    if (base === null) return;
    var total = base, x = X();
    if (x) total += x.perPiece();
    toeslagen().forEach(function (t) { total += t.cents; });
    var txt = fmt(G && G.active() ? G.centsTotal() : total * pieces());
    if (out.textContent !== txt) out.textContent = txt;
    syncAantal(txt);
  }

  function init() {
    updateTotal();
    document.addEventListener('tt:extra', updateTotal);
    document.addEventListener('tt:groep', updateTotal);
    document.addEventListener('input', function (e) { if (e.target && e.target.hasAttribute && e.target.hasAttribute('data-tt-groep-aantal')) updateTotal(); });
    document.addEventListener('click', function (e) { if (e.target.closest && e.target.closest('[data-tt-groep-min],[data-tt-groep-plus]')) setTimeout(updateTotal, 0); });
    ['input', 'change'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target;
        if (!t || t.name !== 'quantity') return;
        var raw = String(t.value);
        if (ev === 'change' || /^d+$/.test(raw) && parseInt(raw, 10) > QMAX) t.value = String(normQty(raw)); // typing "" or "0" on the way is left alone until the field is left
        updateTotal();
      });
    });
    document.addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('[data-tt-aantal-min],[data-tt-aantal-plus]');
      if (b) stepAantal(b.hasAttribute('data-tt-aantal-plus') ? 1 : -1);
    });
    var host = document.querySelector('.product__info-container') || document.body;
    if (window.MutationObserver) new MutationObserver(updateTotal).observe(host, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['class'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // r28pdp: "Meer opties", ONE folded row (closed by default) for everything that is not needed to order: another design (Ontwerp 2 to 4),
  // the gift message, the group amounts per size and the note. The four pieces are moved here as they are (they carry form="..." and their own scripts find them by
  // data attribute, so the order, the total and the checks work the same). Opens by itself when the link fills one of them (?gelegenheid=, ?groep=), when the group
  // panel opens (event tt:groep), when a field in it has a value (back button, restore) and when the form check needs to show a message inside (borduur-personalisatie.liquid).
  function meerOpties() {
    var notes = document.querySelector('borduur-personalisatie .bp__meer');
    if (!notes || document.querySelector('[data-tt-meer]')) return;
    // r34 koper d34: the group amounts stay under the size pills (a buyer of 12 polo's put all 12 on S: the link was folded under 'Cadeaubericht, extra ontwerp of notitie')
    var parts = ['[data-tt-extra-mount]', '[data-tt-cadeau]'].map(function (s) { return document.querySelector(s); }).filter(Boolean);
    var det = document.createElement('details'), sum = document.createElement('summary'), body = document.createElement('div');
    det.className = 'tt-meer'; det.setAttribute('data-tt-meer', '');
    sum.className = 'tt-meer__kop'; sum.textContent = 'Cadeaubericht, extra ontwerp of notitie'; // r30bezoek: name what is inside, a gift buyer looks for the message
    body.className = 'tt-meer__body';
    parts.forEach(function (p) { body.appendChild(p); });
    body.appendChild(notes);
    det.appendChild(sum); det.appendChild(body);
    var bp = document.querySelector('borduur-personalisatie .bp__opts');
    var disc = bp && bp.querySelector('.bp__disclaimer');
    if (disc) bp.insertBefore(det, disc); else notes.ownerDocument.body.appendChild(det);
    function filled() {
      var g = document.querySelector('[data-tt-groep]'), c = det.querySelector('[data-tt-cadeau-in]'), n = det.querySelector('[data-bp-notes]');
      return !!((g && !g.hidden) || (c && c.value.trim()) || (n && n.value.trim()) || det.querySelector('.tt-ex[data-tt-ex]'));
    }
    var p = new URLSearchParams(window.location.search);
    if ((p.get('gelegenheid') || '').trim() || p.has('groep') || filled()) det.open = true;
    document.addEventListener('tt:groep', function () { if (filled()) det.open = true; });
    window.addEventListener('pageshow', function () { if (filled()) det.open = true; });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', meerOpties); else meerOpties();

  // ?gelegenheid=<key>: show one line above the upload and carry the key on the order (properties[_Gelegenheid]).
  // Only the five keys the snippet defines count; anything else (missing, unknown, inherited names) does nothing.
  function occasion() {
    var line = document.querySelector('[data-bp-occasion]'), out = document.querySelector('[data-bp-occasion-out]');
    if (!line || !out) return;
    var key = new URLSearchParams(window.location.search).get('gelegenheid');
    if (!key || !/^[a-z]{1,12}$/.test(key)) return;
    var attr = 'data-occ-' + key;
    if (!line.hasAttribute(attr)) return;
    line.textContent = line.getAttribute(attr);
    line.hidden = false;
    // the occasion line for a name says the same sentence: show it once
    if (key === 'naam') { var nh = document.querySelector('[data-bp-naamhint]'); if (nh) nh.hidden = true; }
    // r34keur K1: the name link opens the text tab, not the upload (the old detour: draw the name, spelling in the notes)
    if (key === 'naam') { var tab = function () { var k = document.querySelector('[data-tt-btx-modus="tekst"]'); if (k && k.getAttribute('aria-pressed') !== 'true') k.click(); }; if (document.readyState === 'complete') tab(); else addEventListener('load', tab); }
    out.value = key;
    out.disabled = false;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', occasion); else occasion();

  // Own submit handler (no window.fetch override, no Ride internals): one /cart/add.js call with an items array
  // [garment, surcharge lines, one line per extra design (+ its format surcharge)], then the cart page. Runs after the snippet's validation, which stops invalid submits first.
  var busy = false;
  // the product name only: a clone of the h1 without its sub line, <style> and <script> (r16rep: textContent of .product__title leaked CSS into the cart properties)
  var cleanTitle = function () {
    var h = document.querySelector('.product__title h1') || document.querySelector('h1');
    if (!h) return '';
    var c = h.cloneNode(true);
    c.querySelectorAll('.tt-h1-sub, style, script').forEach(function (n) { n.remove(); });
    return c.textContent.replace(/\s+/g, ' ').trim();
  };
  var choices = function () {
    var t = cleanTitle();
    var half = t.slice(0, Math.floor(t.length / 2)).trim();
    if (half && t === half + ' ' + half) t = half; // the title block repeats itself for screen readers
    var opts = [];
    document.querySelectorAll('variant-selects select, variant-radios input:checked').forEach(function (el) {
      var name = el.name || '';
      if (/uitvoering/i.test(name) || /uitvoering/i.test((el.closest('fieldset') || {}).textContent || '')) return;
      var val = el.tagName === 'SELECT' ? (el.options[el.selectedIndex] || {}).value : el.value;
      if (val) opts.push(val);
    });
    return { title: t, opts: opts };
  };
  var label = function () { var c = choices(); return c.opts.length ? c.title + ' (' + c.opts.join(', ') + ')' : c.title; };
  // success (r16rep): stay on the page and say WHAT went into the cart: the first sentence is the t_added setting, then name, colour, size and
  // placement, a 44 px button to the cart and a text link that closes the note. One element [data-bp-ok] (the buy bar watches its hidden state),
  // position: fixed in tt-pdp.css so it is in the viewport without scrolling. Refresh the header count (sections API).
  function done(host, btn, sum) {
    busy = false;
    if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
    var ok = host.querySelector('[data-bp-ok]');
    if (!ok) {
      ok = document.createElement('div'); ok.className = 'bp__ok'; ok.setAttribute('data-bp-ok', ''); ok.setAttribute('role', 'status'); ok.setAttribute('aria-live', 'polite');
      var k = document.createElement('p'); k.className = 'bp__ok-kop'; ok.appendChild(k);
      var r = document.createElement('p'); r.className = 'bp__ok-regel'; ok.appendChild(r);
      var a = document.createElement('a'); a.className = 'bp__ok-cart'; a.href = '/cart'; a.textContent = host.dataset.nCart || 'Naar winkelwagen'; ok.appendChild(a);
      var c = document.createElement('button'); c.type = 'button'; c.className = 'bp__ok-door'; c.textContent = 'Verder winkelen';
      c.addEventListener('click', function () { ok.hidden = true; });
      ok.appendChild(c);
      host.appendChild(ok);
    }
    ok.querySelector('.bp__ok-kop').textContent = host.dataset.nAdded || '';
    ok.querySelector('.bp__ok-regel').textContent = [sum.title].concat(sum.opts, sum.pos ? [sum.pos] : []).filter(Boolean).join(', ');
    ok.hidden = false;
    fetch('/?sections=cart-icon-bubble').then(function (r) { return r.json(); }).then(function (j) {
      var html = j && j['cart-icon-bubble']; var el = document.getElementById('cart-icon-bubble');
      if (html && el) { var d = document.createElement('div'); d.innerHTML = html; var n = d.querySelector('#cart-icon-bubble'); if (n) el.innerHTML = n.innerHTML; }
    }).catch(function () {});
  }
  function fail(host, msg) {
    var box = host.querySelector('[data-bp-err-submit]'), txt = host.querySelector('[data-bp-err-submit-txt]');
    if (box && txt) { txt.textContent = msg || host.dataset.nSubmit || ''; box.hidden = false; }
  }
  // r18maten: the first size went in with the file (multipart). Read the design URL from that answer, put it on every line as "Upload jouw design",
  // then add each other size as its own set of lines (garment, surcharges, extra designs) with the same properties, its own _tt_link and its own quantity.
  // A failure halfway says which sizes are in the cart and which are not: no silent half order.
  function postJson(url, body) {
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error((j && (j.description || j.message)) || ('status ' + r.status)); return j; }); });
  }
  var sizeName = function (l) { return l.kleur + ' ' + l.maat + ' (' + l.qty + ')'; };
  function groupRest(tmpl, g, link) {
    var inCart = [g[0]], todo = g.slice(1);
    var props = function (it, newLink) {
      var p = {}, o = it.properties || {};
      Object.keys(o).forEach(function (k) { p[k] = o[k]; });
      if (p._tt_link && newLink) p._tt_link = newLink;
      if (p._Ontwerpbestand) p['Upload jouw design'] = p._Ontwerpbestand;
      return p;
    };
    var lost = function (why) {
      var e = new Error('Niet alles staat in je winkelwagen' + (why ? ' (' + why + ')' : '') + '. Erin: ' + inCart.map(sizeName).join(', ') + '. Nog niet: ' + todo.map(sizeName).join(', ') + '. Controleer je winkelwagen en voeg de rest toe.');
      e.partial = true; return e;
    };
    if (!tmpl[0] || !(tmpl[0].properties || {})._Ontwerpbestand) return Promise.reject(lost('ontwerplink ontbreekt'));
    // r20wagen: 2 requests at the same time instead of 1 + 1 + one per size: ONE /cart/add.js with every other size (all lines of all sizes in the items
    // array, atomic: all in or none) and the /cart/change.js that gives the first lines the design URL. 14 pieces in 4 sizes: 3 requests (was 5 zonder extra ontwerpen).
    var rest = g.slice(1), items = [];
    rest.forEach(function (l, n) {
      tmpl.forEach(function (it, idx) {
        items.push({ id: idx === 0 ? l.variant : it.variant_id, quantity: l.qty, properties: props(it, link + 'm' + (n + 1)) });
      });
    });
    var settle = function (p) { return p.then(function () { return null; }, function (e) { return e || new Error(''); }); };
    var add = rest.length ? postJson('/cart/add.js', { items: items }).then(function () { inCart.push.apply(inCart, rest); todo.length = 0; }) : Promise.resolve();
    // r30bezoek: the change waits for the add. At the same time on one cart, Shopify sometimes kept the cart of the add and dropped the change
    // (aantal-per-maat red 3 of 9 runs: the first size line kept the file name instead of the design link)
    var fix = settle(add);
    tmpl.forEach(function (it) {
      if (!(it.properties || {})._Ontwerpbestand) return;
      fix = fix.then(function () { return postJson('/cart/change.js', { id: it.key, quantity: it.quantity, properties: props(it) }); });
    });
    return Promise.all([settle(add), settle(fix)]).then(function (r) {
      if (r[0]) throw lost(r[0].message);
      if (r[1]) {
        var e = new Error('Alle maten staan in je winkelwagen, maar de ontwerplink op de eerste regel is niet bijgewerkt (' + (r[1].message || 'onbekende fout') + '). Controleer je winkelwagen. Erin: ' + inCart.map(sizeName).join(', ') + '.');
        e.partial = true; throw e;
      }
    });
  }

  document.addEventListener('submit', function (e) {
    var host = document.querySelector('borduur-personalisatie');
    var form = e.target;
    if (!host || !form || !form.getAttribute || form.getAttribute('id') !== host.dataset.form) return;
    e.preventDefault();
    if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    if (busy) return;
    var G = window.TTGroep, grp = null;
    if (G && G.isOpen()) {
      if (!G.total()) { G.error('Kies eerst bij minstens één maat een aantal, of sluit "Voor een groep" om één stuk te kopen.'); return; }
      grp = G.lines();
    }
    var errBox = host.querySelector('[data-bp-err-submit]'); if (errBox) errBox.hidden = true;
    var okBox = host.querySelector('[data-bp-ok]'); if (okBox) okBox.hidden = true;
    var btn = form.querySelector('button[name="add"]');
    var qIn = qField(); if (qIn && !qIn.disabled) qIn.value = String(normQty(qIn.value)); // r20pdp: a clean number goes into the add, whatever was typed
    var src = new FormData(form), fd = new FormData();
    var x = X(), exs = x ? x.items() : [], withExtra = exs.length > 0;
    var link = 'tt' + Date.now().toString(36) + Math.random().toString(36).slice(2, 6);
    fd.append('items[0][id]', grp ? grp[0].variant : src.get('id'));
    fd.append('items[0][quantity]', grp ? String(grp[0].qty) : String(pieces()));
    src.forEach(function (v, k) {
      var m = /^properties\[(.*)\]$/.exec(k);
      if (m && typeof v !== 'string' && !v.size && !v.name) return; // r21upload: an empty file field (the file follows by mail) is no property
      if (m && typeof v === 'string' && !v.trim()) return; // eindaudit F6: an empty field is no property on the order
      if (m) fd.append('items[0][properties][' + m[1] + ']', v);
    });
    var file = host.querySelector('[data-bp-file]');
    if (file && file.files && file.files[0] && file.files[0].name !== 'borduurtekst.png') fd.set('items[0][properties][Upload jouw design]', file.files[0].name); // also after back/restore; r34: a typed name (tt-borduurtekst.js) is no upload
    var toes = toeslagen(), n = 1, qty = grp ? String(grp[0].qty) : String(pieces());
    if (grp) { fd.append('items[0][properties][Groepsbestelling]', G.total() + ' stuks'); fd.append('items[0][properties][_tt_link]', link); }
    if (withExtra) fd.append('items[0][properties][Extra ontwerpen]', x.summary()); // visible on the garment line: the studio and the customer read it
    if (!grp && (withExtra || toes.length)) fd.append('items[0][properties][_tt_link]', link);
    // surcharge lines first, same quantity as the garment; each points at the garment line through _tt_link
    toes.forEach(function (t) {
      fd.append('items[' + n + '][id]', t.variant);
      fd.append('items[' + n + '][quantity]', qty);
      fd.append('items[' + n + '][properties][_tt_link]', link);
      fd.append('items[' + n + '][properties][_tt_toeslag]', t.kind);
      fd.append('items[' + n + '][properties][Toeslag bij]', label());
      n++;
    });
    // r17extra: per extra design a format surcharge line (when the format has one) and ONE extra-design line, both with the quantity of the garment
    exs.forEach(function (e) {
      if (e.fmt && e.fmt.cents > 0 && e.fmt.variant) {
        fd.append('items[' + n + '][id]', e.fmt.variant);
        fd.append('items[' + n + '][quantity]', qty);
        fd.append('items[' + n + '][properties][_tt_link]', link);
        fd.append('items[' + n + '][properties][_tt_toeslag]', 'formaat');
        fd.append('items[' + n + '][properties][Toeslag bij]', label() + ' (ontwerp ' + e.n + ')');
        n++;
      }
    });
    exs.forEach(function (e) {
      var p = 'items[' + n + '][properties]';
      fd.append('items[' + n + '][id]', x.variant);
      fd.append('items[' + n + '][quantity]', qty);
      fd.append(p + '[_tt_link]', link);
      fd.append(p + '[Extra design bij]', label());
      fd.append(p + '[Ontwerp]', String(e.n));
      fd.append(p + '[Kant]', e.side);
      fd.append(p + '[Positie]', e.pos === 'Overig' && e.plek ? e.plek : e.pos);
      fd.append(p + '[Formaat]', e.fmt.label);
      if (e.file.name === 'ontwerp-volgt-per-mail.txt') { fd.append(p + '[Ontwerpbestand]', 'Volgt per mail naar info@triplethread.nl'); n++; return; } // r21upload: too big for the upload, the customer mails it
      fd.append(p + '[Upload jouw design]', e.file.name);
      fd.append(p + '[_Ontwerpbestand]', e.file);
      n++;
    });
    var ch = choices(), pos = src.get('properties[Positie]') || '';
    if (pos === 'Overig' && src.get('properties[Plek]')) pos = src.get('properties[Plek]');
    var sumGroup = grp ? G.total() + ' stuks in ' + grp.length + (grp.length === 1 ? ' maat' : ' maten') : '';
    var sum = { title: ch.title, opts: grp ? [sumGroup] : ch.opts.concat(pieces() > 1 ? [pieces() + ' stuks'] : []), pos: pos + (exs.length ? ' + ' + exs.length + ' extra ontwerp' + (exs.length > 1 ? 'pen' : '') : '') };
    busy = true;
    if (btn) { btn.disabled = true; btn.setAttribute('aria-busy', 'true'); }
    fetch('/cart/add.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (res.ok && grp) {
          return groupRest(res.j.items || [res.j], grp, link).then(function () { done(host, btn, sum); });
        }
        if (res.ok) {
          // r17extra: remember the design file URL so the product page can put it back after "back" from the cart (tt-ontwerp-bewaar.js)
          try { var it0 = (res.j.items || [res.j])[0], u0 = it0 && it0.properties && it0.properties._Ontwerpbestand; if (u0) sessionStorage.setItem('tt-ontwerp-laatste:' + location.pathname, String(u0)); } catch (x) {}
          done(host, btn, sum); return;
        }
        throw new Error((res.j && (res.j.description || res.j.message)) || '');
      })
      .catch(function (err) {
        busy = false;
        if (btn) { btn.disabled = false; btn.removeAttribute('aria-busy'); }
        fail(host, err && err.message);
      });
  }, true);
  // r16rep: a finger does not drag: on a touch device the upload box drops "of sleep het hierheen" and keeps the bold part
  function touchDrop() {
    if (!window.matchMedia || !matchMedia('(hover: none) and (pointer: coarse)').matches) return;
    document.querySelectorAll('.bp__drop-text').forEach(function (el) {
      [].slice.call(el.childNodes).forEach(function (n) { if (n.nodeType === 3) el.removeChild(n); });
    });
  }
  // r16rep: while placement or format is in view the phone dock grows to 144 px (tt-pdp.css [data-tt-groot]): the garment with the design is readable
  function dockGrow() {
    var dock = document.querySelector('[data-bp-dock]');
    if (!dock || !window.IntersectionObserver) return;
    var seen = {}, io = new IntersectionObserver(function (es) {
      es.forEach(function (e) { seen[e.target.getAttribute('data-tt-dockwatch')] = e.isIntersecting; });
      var on = Object.keys(seen).some(function (k) { return seen[k]; });
      if (on) dock.setAttribute('data-tt-groot', ''); else dock.removeAttribute('data-tt-groot');
    }, { rootMargin: '-100px 0px -90px 0px' });
    ['[data-tt-plek]', '[data-bp-formaat]'].forEach(function (sel, i) {
      var el = document.querySelector(sel); if (!el) return;
      el.setAttribute('data-tt-dockwatch', String(i)); io.observe(el);
    });
  }
  function r16() { touchDrop(); dockGrow(); }
  if (document.readyState === 'complete') r16(); else addEventListener('load', r16);
  // 'Maattabel' link next to the label Maat: opens the size guide modal (section ss-size-guide-2),
  // on the Hoodie tab when the product is a hoodie. Silent no-op when the section is absent.
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-tt-maattabel]');
    if (!b) return;
    var toggle = document.querySelector('[class^="size-toggle-"], [class*=" size-toggle-"]');
    if (!toggle) return;
    toggle.click();
    if (b.dataset.tab !== 'hoodie') return;
    var tabs = document.querySelector('[class^="size-modal-toggles-"]:not([class*="inner"])');
    if (tabs && !tabs.classList.contains('active')) tabs.click();
  });
})();
